import "./styles.css"
export const Card: React.FC<{ name: string, id: string, tooltip?: string }> = ({ ...props }) => {
  const { name, id } = props
  return (
    <div className="card py-3 px-1 text-center my-2" id={id}>
      <strong>{name}</strong>
    </div>
  )
}